import { observer } from "mobx-react";
import cls from "classnames";
import LinkDialog from "../LinkDialog";
import styles from "./index.module.scss";

interface IProps {
  sourceIcon?: string;
  source?: string;
  title?: string;
  url?: string;
  desc?: string;
  refIndex: number;
}

const RefCircle: React.FC<IProps> = ({
  sourceIcon,
  source,
  title,
  url,
  desc,
  refIndex,
}) => {
  return (
    <LinkDialog
      placement="bottom"
      popoverProps={{
        // sourceIcon: "",
        // source: "读护士都",
        // title: "哈哈哈哈哈哈哈",
        // desc: "hh好苏好的速滑hh好苏好的速滑hh好苏好的速滑hh好苏好的速滑hh好苏好的速滑",
        // url: "https://www.baidu.com",
        sourceIcon,
        source,
        title,
        desc,
        url,
        className: styles.refContentBox,
        titleCls: styles.refTitle,
        topCls: styles.topContentBox,
        descCls: styles.refDesc,
        onClick: () => {
          !!url && window.open(url, "_blank");
        },
      }}
    >
      <span className={styles.ref}>
        <span className={styles.text}>{refIndex + 1}</span>
      </span>
    </LinkDialog>
  );
};

export default RefCircle;
